import React from "react";
import { Link } from "react-router-dom";

const HeaderAuth = () => {
  return (
    <header className="header-auth">
      <div className="logo-container">
        <img src="../assets/images/cinef.png" alt="Logo" className="logo" />
      </div>
      <Link to="/" className="btn-home">Accueil</Link>

      <style>{`
        .header-auth {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 15px 30px;
          background: white;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        }

        .logo-container {
          display: flex;
          align-items: center;
          background:#008A44;
        }

        .logo {
          width: 80px;
        }

        .btn-home {
          background: #008A44;
          color: white;
          padding: 10px 15px;
          border-radius: 5px;
          text-decoration: none;
          font-weight: bold;
        }

        .btn-home:hover {
          background: #006A33;
        }
      `}</style>
    </header>
  );
};

export default HeaderAuth;
